import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Roofing, AssistWalker, Diversity3, Apps, ContactPhone } from "@mui/icons-material";
import apilink from "../globals/Baseurls";
import axios from "axios";
import "@fontsource/open-sans"; // Defaults to weight 400
import "@fontsource/open-sans/400.css"; // Specify weight
import "@fontsource/open-sans/400-italic.css"; // Specify weight and style

import "@fontsource/caveat"; // Defaults to weight 400
import "@fontsource/caveat/400.css"; // Specify weight

const Layout = () => {
  const [screen, setScreen] = useState("home");
  const [sick, setSick] = useState(0);
  const navigate = useNavigate();

  const handleNavigation = (route) => {
    setScreen(route);
    navigate("/app/" + route);
  };

  useEffect(() => {
    const getAsyncData = async () => {

      const storedUser = await JSON.parse(
        localStorage.getItem("userFamilyData")
      );
    
      // const storedUser = await JSON.parse(
      //   localStorage.getItem("userSessionData")
      // );
 
      const baseUrl = apilink.link;
      await axios
      .get(`${baseUrl}/family/members/sick/${storedUser.familycode}`, {
          headers: {
            "Content-Type": "application/json",
          },
        })

        .then((response) => {
          if (response.data.message == "Successfull") {
            setSick(
              response.data.records.filter((item) => item.healed === "No").length
            );
          }
        })
        .catch((error) => {
         
          console.log("rrrr"+error.response.data.message);
        });
    };
    getAsyncData();
  }, []);
  
  return (
    <>
      <nav
        style={{ paddingInline: "15px" }}
        className="navbar fixed-top navbar-light bg-light"
      >
        
          <h1 className="navbar-brand mb-0" style={{ fontFamily: "Caveat", fontSize: 20}}>family<b>Tree</b></h1>
          <img
            alt="logo"
            style={{ width: "80px", height: "50px", resizeMode: "stretch" }}
            src={require("./pic1.webp")}
          />
       
      </nav>
      <div className="container-fluid">
        <div id="page-home" className="active">
        <div className="block" style={{ marginTop: "80px", marginBottom: "80px"}}>
            {/* <h2>The standard Lorem Ipsum passage, used since the 1500s</h2> */}
            <Outlet />
          </div>
        </div>
      </div>
      <footer className="footer" style={{borderTop: "3px solid white", height: "65px" }}>
        <div
          id="buttonGroup"
          className="btn-group selectors"
          role="group"
          aria-label="Basic example"
        >
          <button
            id="home"
            type="button"
            className="btn btn-secondary button-active"
          >
            <div
              onClick={() => handleNavigation("home")}
              className="selector-holder"
            >
              <center>
                <Roofing style={screen === "home"?{color: '#C19A6B'}:{color: '#779d38'}}/>
                <br />
                <span style={screen === "home"?{color: '#C19A6B',fontFamily: "Open Sans"}:{color: '#779d38',fontFamily: "Open Sans"}}>Home</span>
              </center>
            </div>
          </button>
          <button
            id="feed"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("sick")}
              className="selector-holder"
            >
              <center>
              <AssistWalker style={screen === "sick"?{color: '#C19A6B'}:{color: '#779d38'}}/>
                <br />
                <span style={screen === "sick"?{color: '#C19A6B',fontFamily: "Open Sans"}:{color: '#779d38',fontFamily: "Open Sans"}}>Sick({sick})</span>
              </center>
            </div>
          </button>
          <button
            id="create"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("late")}
              className="selector-holder"
            >
              <center>
                <Diversity3 style={screen === "late"?{color: '#C19A6B'}:{color: '#779d38'}}/>
                <br />
                <span style={screen === "late"?{color: '#C19A6B',fontFamily: "Open Sans"}:{color: '#779d38',fontFamily: "Open Sans"}}>Late</span>
              </center>
            </div>
          </button>
          <button
            id="account"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("contacts")}
              className="selector-holder"
            >
              <center>
                <ContactPhone style={screen === "contacts"?{color: '#C19A6B'}:{color: '#779d38'}}/>
                <br />
                <span style={screen === "contacts" ?{color: '#C19A6B', fontFamily: "Open Sans"}:{color: '#779d38', fontFamily: "Open Sans"}}>Contacts</span>
              </center>
            </div>
          </button>
          <button
            id="account"
            type="button"
            className="btn btn-secondary button-inactive"
          >
            <div
              onClick={() => handleNavigation("more")}
              className="selector-holder"
            >
              <center>
                <Apps style={screen === "more"?{color: '#C19A6B'}:{color: '#779d38'}}/>
                <br />
                <span style={screen === "more" ?{color: '#C19A6B', fontFamily: "Open Sans"}:{color: '#779d38', fontFamily: "Open Sans"}}>More</span>
              </center>
            </div>
          </button>
        </div>
      </footer>
    </>
  );
};

export default Layout;
